exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media screen and (max-width: 750px) {\n.v-btn[data-v-2af77462] {\n    min-width: 60px !important;\n    margin: inherit;\n}\n}", ""]);

// exports
